import { z } from 'zod';
// Phase 2.5 session 6 — attribution_policy_proposal feed card
// payload. Posted by runAttributionPolicyProposerForBrand when
// Mag's mag-attribution-policy agent recommends a model different
// from the brand's current setting.
export const attributionModelSchema = z.enum([
    'last_click',
    'time_decay',
    'position_based',
    'linear',
]);
/** Snapshot of the brand's data shape that informed Mag's pick.
 *  Carried in the payload so the founder reading the card sees the
 *  exact numbers Mag saw, not whatever the live shape looks like
 *  when they open the card. */
export const attributionPolicyDataShapeSchema = z.object({
    /** Total conversion events in the last 30 days (any source). */
    conversionsLast30d: z.number().int().min(0),
    /** Per-week average derived from conversionsLast30d / 4.3. */
    conversionsPerWeek: z.number().min(0),
    /** Median number of distinct meta touchpoints per conversion in the
     *  trailing window. 0 when no multi-touch journeys observed. */
    medianMetaTouchesPerConversion: z.number().min(0),
    /** Share of conversions attributed to each source (last-click view).
     *  Sums to ≤ 1.0; remainder is direct/organic/unknown. */
    metaShare: z.number().min(0).max(1),
    googleShare: z.number().min(0).max(1),
    /** Whether multi-touch journeys exist at all. Cheap signal —
     *  any visitor with 2+ utm_content values before conversion. */
    hasMultiTouchJourneys: z.boolean(),
});
export const attributionPolicyProposalStateSchema = z.enum([
    'open',
    'applied',
    'dismissed',
    'expired',
]);
export const attributionPolicyProposalPayloadSchema = z.object({
    kind: z.literal('attribution_policy_proposal'),
    weekStartDate: z.string(),
    tz: z.string().min(1).max(60),
    state: attributionPolicyProposalStateSchema,
    /** Brand's current model when the proposal was generated. */
    currentModel: attributionModelSchema,
    /** Mag's recommendation. When equal to currentModel the proposer
     *  wouldn't have posted; the schema permits it for completeness. */
    recommendedModel: attributionModelSchema,
    /** Agent's confidence 1-10. */
    confidence: z.number().int().min(1).max(10),
    /** Mag-voice rationale. */
    rationale: z.string().min(1).max(500),
    /** Short reason for the dashboard chip. */
    shortReason: z.string().min(1).max(100),
    /** Snapshot of the data shape Mag read. */
    dataShape: attributionPolicyDataShapeSchema,
    /** Apply timestamp + the previous model so we can show "switched
     *  from X to Y on date Z" in the campaign rollup card going
     *  forward. */
    appliedAt: z.string().datetime().optional(),
    previousModel: attributionModelSchema.optional(),
    /** LLM cost. */
    costUsd: z.number().min(0),
});
//# sourceMappingURL=attribution-policy-card.js.map